<template>
  <div class="task-new-filter--fileM" v-if="!loading">
    <Search v-model="keyword" placeholder="搜索文件名称"></Search>
    <div class="line"></div>
    <SortList v-model="sort_rule"></SortList>
    <ModCheck @change="togaView"></ModCheck>
  </div>
</template>
<script>
import Search from '@/components/taskFilterBox/search'
import SortList from './sortList'
import ModCheck from './modCheck'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  props: [ 'loading'],
  components: {
    Search,
    SortList,
    ModCheck
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ...mapState('template/template', {
      queryMsg: state => state.queryMsg
    }),
    keyword: {
      get() {
        return this.queryMsg.keyword
      },
      set(val) {
        this.set_keyword(val)
      }
    },
    sort_rule: {
      get() {
        return this.queryMsg.sort_rule
      },
      set(val) {
        this.set_sort_rule(val)
      }
    }
  },
  methods: {
    ...mapMutations('template/template', ['set_keyword', 'set_sort_rule', 'set_mod_view']),
    togaView(val) {
      this.set_mod_view(val)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-new-filter--fileM {
  display: flex;
  align-items: center;
  .fadeDown-enter-active {
    animation: fadeInUpBig 1s;
  }
  .fadeDown-leave-to {
    animation: fadeOutDownBig 1s;
  }
  .line {
    height: 16px;
    width: 1px;
    @include bgColorOpacity(.16);
    margin-left: 8px;
  }
  .el-dropdown .el-dropdown-link {
    @include fontColorOpacity(.6);
    font-size: 14px;
    font-weight: 400;
    i {
      @include fontColorOpacity(.6);
      font-weight: 400;
      margin-right: 9px;
    }
  }
  .filter-status {
    margin-left: 8px;
  }
  .el-dropdown-link {
    padding:8px;
  }
}
</style>
